import { compose } from '@reduxjs/toolkit';
import { createDownloadReportReducer } from './createDownloadReport';
import { fetchAllDownloadReportsByReportTypeReducer } from './fetchAllDownloadReportsByReportType';

export const extraReducers = compose(fetchAllDownloadReportsByReportTypeReducer, createDownloadReportReducer);

export { createDownloadReport } from './createDownloadReport';
export { fetchAllDownloadReportsByReportType } from './fetchAllDownloadReportsByReportType';
